module.exports = __webpack_public_path__ + "img/Tournaments_2208x1242_7.e2ca0e74.png";